<template>
    <div class="discuss-history-note-bubble">
        <div v-show="showBubble" class="discuss-history-note-content" @click="clickBubble">
            <i class="iconfont icon-arrow-note"></i><span class="discuss-history-note">{{noteText}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DiscussNoteBubble',
    props: {
        bubbleFunc: {
            type: Function,
            default() { return function() {} }
        }
    },
    computed: {
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanRoomAtReplyMeList() {
            return this.$store.state.discuss.lunpanRoomAtReplyMeList;
        },
        lunpanRoomReplyMeList() {
            return this.$store.state.discuss.lunpanRoomReplyMeList;
        },
        lunpanHistoryList() {
            return this.$store.state.discuss.lunpanHistoryList;
        },
    },
    data() {
        return {
            showBubble: false,
            noteText: '有人@我'
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 1000);
        this.$bus.on('checkDiscussBubbleStatus', this.checkStatus);
    },
    destroyed() {
        this.$bus.off('checkDiscussBubbleStatus', this.checkStatus);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('discuss-fate-topbar')[0];
            if(topDiv) {
                this.$el.style.top = (topDiv.clientHeight+35) + 'px';
            }
        },
        checkStatus() {
            if(this.lunpanRoomAtReplyMeList.length > 0) {
                this.showBubble = true;
                var firstItem = this.lunpanRoomAtReplyMeList[0];
                if(firstItem.f_type == 1){
                    this.noteText = '有人@我'; 
                }else if(firstItem.f_type == 2){
                    this.noteText = '有人回复我';
                }
            }else {
                this.showBubble = false;
                this.noteText = '';
            }
        },
        clickBubble() {
            var me = this, curIndex = -1;
            if(this.lunpanRoomAtReplyMeList.length > 0) {
                // 点击查看@我
                var curMId = this.lunpanRoomAtReplyMeList[0].mid,
                    curData = _.find(this.lunpanHistoryList, data=>{return data.id==curMId}),
                    curIndex = _.findIndex(this.lunpanHistoryList, data=>{return data.id==curMId});
                console.log('clickBubble-------', curMId, curIndex, curData, this.lunpanData);
                if(curIndex != -1) {
                    this.$bus.emit('scrollToDiscussAssignPosByIndex', curIndex);
                    // 响应到服务器,设置为已读
                    this.$store.dispatch('discuss/setLunpanRoomAtMeReaded', {
                        params: {
                            rid: this.lunpanData.rid,
                            mid: curData.id
                        },
                        cb: function() {
                            me.checkStatus();
                        }
                    });
                }
            }
        }
    }
}
</script>